module.exports = __webpack_public_path__ + "static/media/instant_myway.e805be06.svg";